import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jweb-mpajax-servlet',
	templateUrl:'./JWebMPAjaxServletPluginCompPage.html',
	styles: [],
	styleUrls:['./JWebMPAjaxServletPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JWebMPAjaxServletPluginCompPage
{
	mdContent_1039 = `\`\`\`java
import com.jwebmp.vertx.JWebMPAjaxServlet;
\`\`\``;
	mdContent_1040 = `\`\`\`java
JWebMPAjaxServlet()
\`\`\``;
	mdContent_1041 = `\`\`\`java
// When a button click event fires:
button.addEvent(new OnClickAdapter(button) {
    @Override
    public void onClick(AjaxCall&lt;?&gt; call, AjaxResponse&lt;?&gt; response) {
        response.addComponent(new Paragraph&lt;&gt;().setText("Clicked!"));
    }
});
// The browser POSTs to /jwajax, handled by JWebMPAjaxServlet
\`\`\``;
}
